import { render, staticRenderFns } from "./LoginPartner.vue?vue&type=template&id=1f6aec10&scoped=true"
import script from "./LoginPartner.vue?vue&type=script&lang=js"
export * from "./LoginPartner.vue?vue&type=script&lang=js"
import style0 from "./LoginPartner.vue?vue&type=style&index=0&id=1f6aec10&prod&scoped=true&lang=css"
import style1 from "./LoginPartner.vue?vue&type=style&index=1&id=1f6aec10&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6aec10",
  null
  
)

export default component.exports